import type { ProjectType } from '~/composables/useProjectConfig'

export interface QueryData {
  projectType: ProjectType
  languageCode: string
  shareuid: string // 分享者uid
  channel: string // openid/渠道id
  source: 'ldshop' | 'ldplayer' | 'ldplayer-x' | string // 进入商城的来源 用于tp传参
  gclid: string // 谷歌投放默认带上，下单的时候带给后端
  /** 助手的Channel */
  platformChannel: string
  /** 中台token，token+uid可实现自动登录 */
  platformToken: string
  /** 设置货币 */
  platformCurrency: string
  /** 中台uid */
  platformUid: string
  /** 邀请码 */
  inviteCode: string
  /** 用户来源维度,登录的时候传输 */
  ws: string | null
  [key: string]: any
}

function extractContent(input: string) {
  // 去掉所有引号
  // const cleaned = input.replace(/['"]/g, '')

  // 去除前后的空白字符
  const trimmed = input.trim()

  if (['undefined', 'null'].includes(trimmed)) {
    return ''
  };

  // 返回处理后的内容
  return trimmed.length > 0 ? trimmed : '' // 如果内容为空，返回 null
}

export const useInitQuery = defineStore(
  'initQuery',
  () => {
    const queryData = useSessionStorage('initQuery', {
      languageCode: '',
      shareuid: '',
      channel: '800000',
      source: 'ldshop',
      projectType: 'production',
      gclid: '',
      platformChannel: '',
      platformToken: '',
      platformUid: '',
      platformCurrency: '',
      inviteCode: '',
      ws: null,
    })
    function initQueryData() {
      if (process.server) {
        queryData.value.platformCurrency = ''
      }
      const route = useRoute()
      loKeys(route.query).forEach((key: string) => {
        if (!loHas(queryData.value, key)) {
          return
        }
        if (key === 'languageCode') {
          queryData.value[key] = handleLocale(route.query[key] as string)
          return
        }

        const value = extractContent(route.query[key] as string)
        if (key === 'platformChannel') {
          queryData.value[key] = value?.split('?')?.[0] || ''
          return
        }
        queryData.value[key] = value
      })
    }
    /** 处理ssr阶段货币参数的赋值 */
    function handleCurrencyQueryInitForSSR() {
      const { setCurrentCurrency } = useCurrencyStore()
      if (process.server && queryData.value.platformCurrency) {
        setCurrentCurrency(queryData.value.platformCurrency)
      }
    }

    const isShare = computed(() => !!queryData.value.shareuid)

    /** 助手 */
    const isLdplayerX = computed(() => queryData.value?.source === 'ldplayer-x')

    return {
      queryData,
      initQueryData,
      isShare,
      isLdplayerX,
      handleCurrencyQueryInitForSSR,
    }
  },
  {
    persist: [
      {
        // storage: persistedState.sessionStorage,
        // paths: ['queryData'],
      },
    ],
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInitQuery, import.meta.hot))
}
